import Action from '../../Action'
import './Maintenance-styles/Maintenance.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import InputAdmin from '../../InputAdmin';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import MultiSelector from '../../MultiSelector';
import Modal from 'rsuite/esm/internals/Overlay/Modal';
import ModalDeleteUSer from '../ModalDeleteUser';
import { DateRangePicker } from 'rsuite';
import isAfter from 'date-fns/isAfter';
import { isBefore, startOfDay } from 'date-fns';
import { addDays, addWeeks, addMonths,startOfMonth } from 'date-fns';
// import { addHours, subHours, addDays, subDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, addMonths } from 'date-fns';
const ModalCreateException =({poolRows,setPoolRows,openAddHostModal,openDeleteUserModal,handleShowPopup,hosts,fetchEvents,languaje,mode,user,devices,server,setRegisterIsValid,dataMantto,setData,loading,setLoading,setError,setEditActive,editActive,closCreateManttoModal})=>{
    //console.log(dataMantto)
    useEffect(()=>{
      if(editActive){
          setPoolRows(dataMantto.hostids)
      }
    },[])
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const dataAgencies=useFetch('cassia/exception_agencies','','','GET',server)
    const dataGroups=useFetch('cassia/host_groups/by_type/1','','','GET',server)
    const dataUsers=useFetch('cassia/users','','','GET',server)
    const dataNotiConfig=useFetch('cassia/maintenance/notifications_config','','','GET',server)
    //console.log(dataUsers)
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const levels=[
        {
            id:1,
            name:'host',
            visual_name:capitalizeFirstLetter(lang[languaje]['dispositivos'])
        },
        {
            id:2,
            name:'group',
            visual_name:capitalizeFirstLetter(lang[languaje]['grupos'])
        },
        
    ]
    const [range, setRange] = useState(((editActive)?[new Date(dataMantto.start_time), new Date(dataMantto.end_time)]:[startOfMonth(new Date()), new Date()]));
    //console.log(range)
    const formatDate=(date)=>{
      const anio = date.getFullYear();
      const mes = String(date.getMonth() + 1).padStart(2, '0');
        const dia = String(date.getDate()).padStart(2, '0');
        const horas = String(date.getHours()).padStart(2, '0');
        const minutos = String(date.getMinutes()).padStart(2, '0');
      // //console.log(`${anio}-${mes}-${dia}T${horas}:${minutos}`)
      return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    }

    const predefinedRanges = [
        {
          label: 'Próximo día',
          value: [new Date(), addDays(new Date(), 1)],
          placement: 'left'
        },
        {
          label: 'Próximos 3 días',
          value: [new Date(), addDays(new Date(), 3)],
          placement: 'left'
        },
        {
          label: 'Próximos 5 días',
          value: [new Date(), addDays(new Date(), 5)],
          placement: 'left'
        },
        {
          label: 'Próxima semana',
          value: [new Date(), addWeeks(new Date(), 1)],
          placement: 'left'
        },
        {
          label: 'Próximas 2 semanas',
          value: [new Date(), addWeeks(new Date(), 2)],
          placement: 'left'
        },
        {
          label: 'Próximo mes',
          value: [new Date(), addMonths(new Date(), 1)],
          placement: 'left'
        }
      ];

    const [ManttoData,setManttoData]=useState({
        name: (editActive)?dataMantto.name:"",
        description: (editActive)?dataMantto.description:"",
        event_type: (editActive)?dataMantto.event_type:"group",
        interested_type: (editActive)?dataMantto.interested_type:"user",
        start_time:(editActive)?dataMantto.start_time: obtenerFechaActualLocal(),
        end_time: (editActive)?dataMantto.end_time:obtenerFechaActualLocal(),
        notification_config_id: (editActive)?dataMantto.notification_config_id:1,
        userids: (editActive)?dataMantto.userids:[],
        groupids: (editActive)?dataMantto.groupids:[],
        hostids: (editActive)?dataMantto.hostids:poolRows,
        usergroupids: (editActive)?dataMantto.usergroupids:[],
        repeat_id:0,//obligatorio catalogo repetir 
        n_repeat:0,//Opcional perzonalizado entero 
        type_repeat:0,//Opcional perzonalizado catalogo  
        occurrence:30,//opcional cantidad de veces que se repetira 
      })
    //console.log(levels.find(element => element.name === "group"),levels.find(element => element.name === "group").id,ManttoData.event_type)

    //   //console.log(levels,ManttoData.event_type)
    //   //console.log(levels.find(element => element.name === ManttoData.event_type).id)
    //console.log(ManttoData)
    //console.log(poolRows)
    useEffect(()=>{
      if(range!=null && range[0]!=null && range[1]!=null){
      
           setManttoData((prevState)=>{
        return {
            ...prevState,
            ['start_time']:formatDate(range[0]),
            ['end_time']:formatDate(range[1])
        }
       
    })
      }
      
    
    },[range])
    useEffect(()=>{
        setManttoData((prevState)=>{
          return {
              ...prevState,
              ['hostids']:poolRows
          }
          
      })
    },[poolRows])
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)

    const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)

    //     //console.log(host)
    useEffect(()=>{
    //    //console.log("cambio host")
       if(host.length>=1){
        //console.log("escribe")
        setHostName(host[0].name)
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['host_id']:host[0].hostid
            }
            
        })
       
       }else{
        //console.log("borra")
        setHostName("")
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['host_id']:0
            }
            
        })
        // setManttoData((prevState)=>{
        //     return {
        //         ...prevState,
        //         ['device_name']:""
        //     }
            
        // })
       }
  },[host])

    const handleChange=(e)=>{
        //console.log(e.target.name)
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }
            
          
       
        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }

        
        
      }

    useEffect(()=>{
     
          if( (ManttoData.name==="" || (ManttoData.event_type=="group" && groupids.length==0) 
           || (ManttoData.event_type=="host" && hostids.length==0) || userids.length==0
          || (ManttoData.repeat_id!=0 && ManttoData.occurrence==0 )
          || (ManttoData.repeat_id==6 && (ManttoData.n_repeat==0 || ManttoData.occurrence==0))
          )   ){
              //console.log('disabled')
              setDisabled(true)
          }else{
              //console.log('no disabled')
              setDisabled(false)
          }
    },[ManttoData])


    const Registrar=()=>{
     
      let method='POST'
      let url_add=''
      let data={
          "exception_agency_id": ManttoData.agency_id,
          "description": ManttoData.description,
          "hostid": ManttoData.host_id,
          "created_at": ManttoData.created_at
        }
      if(editActive){
          method='PUT'
          url_add=dataMantto.id
          
      }
      
      
      
      setLoading(true)
        const fetchDataPost = async () => {
          
       try {
          // //console.log(method,server.url+'/api/v1/cassia/exceptions'+url_add)
        
          // //console.log(localStorage.getItem('access_token'))
            const response = await fetch(server.url+'/api/v1/cassia/maintenance/'+url_add, {
              method: method,  
              headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
              body: JSON.stringify(ManttoData),
            });
          //  //console.log(response)
            if (response.ok) {
              
              const data1 = await response.json();
              setLoading(false)
              // Manejo de la respuesta
              setData(data1)
              // //console.log(data1);
              handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
              fetchEvents()
              closCreateManttoModal()
            setRegisterIsValid(true)
            
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateManttoModal()
            }, 3000);
          
            } else {
              const data1 = await response.json();
              handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
              throw new Error('Error en la solicitud');
            }
          } catch (error) {
              setHostName("")
              // setManttoData({ip:"",host_id:0,date:"",responsible_name:"",auth_name:"",device_description:"",justification:"",previous_state:"",new_state:"",impact:"",result:"",observations:"",files:[],status:'Activo'})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateManttoModal()
            setRegisterIsValid(true)
            
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateManttoModal()
            }, 3000);
            console.error(error);
          }
        };
    
        fetchDataPost();
        
  }
    const closeModal=()=>{
        setEditActive(false)
                closCreateManttoModal()
    }
    useEffect(()=>{
        if(editActive){
            
            setIpValid(validateIp(ManttoData.ip))
        }
    },[])
    const buscar_host=(ip)=>{
        // //console.log("buscar_host")
        
        setLoadingM(true)
          const fetchDataPost = async () => {
            
         try {
            // //console.log(server.url+'/api/v1/cassia/ci/search_host/'+ip)
            const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
                method: 'GET',  
                headers: {
                  'Content-Type': 'application/json',
                  'accept': 'application/json',
                  'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                },
              });
            //   //console.log(response)
              if (response.ok) {
                
                const data1 = await response.json();
                setLoadingM(false)
                // //console.log(data1)
                if(data1.data.length==0){
                    sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
                    setMsgError(capitalizeFirstLetter(lang[languaje]['msgIpNoExiste']))
                    setIpValid(false)
                }else{
                    setIpValid(true)

                }
                sethost(data1.data)
                setDisabled(true)
              } else {
                const data1 = await response.json();
                //console.log(data1)
                throw new Error('Error en la solicitud');
              }
            } catch (error) {
              console.error(error);
            }
          };
      
          fetchDataPost();
        
    }
    const changeOption=(option,index)=>{
        if(option.filter=="Estados"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    ['notification_config_id']:option.value===""?0:(parseInt(option.value))
                }
                
            })
        }else if(option.filter=="Severity"){
         if(!editActive){
             setPoolRows([])
         }
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    ['event_type']:option.value===""?"":(option.label)
                }
                
            })
        }else if(option.filter=="Repeat"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  ['repeat_id']:option.value===""?0:(parseInt(option.value))
              }
              
          })
          let n_type=0
          if(option.value==1){
            n_type=30
          }else if(option.value==2){
            n_type=25
          }else if(option.value==3){
            n_type=52
          }else if(option.value==4){
            n_type=12
          }else if(option.value==5){
            n_type=10
          }else{
            n_type=20
          }
          setManttoData((prevState)=>{
            return {
                ...prevState,
                ['occurrence']:n_type===""?0:(parseInt(n_type))
            }
            
        })
      }if(option.filter=="RepeatType"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    ['type_repeat']:option.value===""?0:(parseInt(option.value))
                }
                
            })
          }


        // setManttoRelation(option.value)
    }

    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError(capitalizeFirstLetter(lang[languaje]['ipNoValida']))
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
      };
    const [resultList,setResultList]=useState([])
    const handleSearchHost=(e)=>{
      
      const term = e.target.value;
      const {name,value}=e.target
      if(name=="ip"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  ['ip']:value
              }
              
          })
      }
      // //console.log(value)
      // setInputIP(value)
      setIpValid(validateIp(value))
      
      const filteredResults = devices.data.hosts.filter((item) => {
          
          return Object.entries(item).some(([key, value]) => {
            if (key === 'ip' || key=== 'Host') {
              return String(value).toLowerCase().includes(term.toLowerCase());
            }
            return false; // Si no es el atributo 'ip', retorna falso para continuar buscando en otros atributos
          });
        });
     
        setResultList(filteredResults)
    }

    //   //console.log(resultList)
    const handleSelected=(element)=>{
        //console.log(element)
        setIpValid(validateIp(element.ip))
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['ip']:element.ip
            }
            
        })
        setListSearchIP(false)
    }
    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const changeMultiOption=(option,index,titulo)=>{
        let attr=""
        if(titulo=="Grupos"){
            attr="groupids"
        }else  if(titulo=="Usuarios"){
             attr="userids"
        }else if(titulo=="Hosts"){
            attr="hostids"
        }
  
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  [attr]:option.map(item => item.value)
              }
              
          })
      }
    const reqField=()=>{
      return(
        <p className='reqField-gs'>
          *
        </p>
      )
    }
    const repeat=[
      {id:0,name:'no repetir',visual:capitalizeFirstLetter(lang[languaje]['noRepetir'])},
      {id:1,name:'Diario',visual:capitalizeFirstLetter(lang[languaje]['repetirDia']),type:capitalizeFirstLetter(lang[languaje]['dias'])},
      {id:2,name:'weekday',visual:capitalizeFirstLetter(lang[languaje]['repetirLV']),type:capitalizeFirstLetter(lang[languaje]['semanaLavoral'])},
      {id:3,name:'Semana',visual:capitalizeFirstLetter(lang[languaje]['repetirSemana']),type:capitalizeFirstLetter(lang[languaje]['semanas'])},
      {id:4,name:'Mes',visual:capitalizeFirstLetter(lang[languaje]['repetirMes']),type:capitalizeFirstLetter(lang[languaje]['meses'])},
      {id:5,name:'Año',visual:capitalizeFirstLetter(lang[languaje]['repetirAnio']),type:capitalizeFirstLetter(lang[languaje]['anios'])},
      {id:6,name:'perzonalizado',visual:capitalizeFirstLetter(lang[languaje]['personalizar'])}
    ]


    const handleKeyPress = (e) => {
      // Permitir solo números, teclas de control y el punto decimal
      const charCode = e.charCode;
      if (
        (charCode >= 48 && charCode <= 57) || // Números 0-9
        charCode === 46 || // Punto decimal
        charCode === 8 || // Retroceso
        charCode === 37 || // Flecha izquierda
        charCode === 39 ||// Flecha derecha
        charCode === 45 //  negativo
      ) {
        return;
      } else {
        e.preventDefault();
      }
    };
    const handlePaste = (e) => {
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      if (!/^-?\d*\.?\d*$/.test(paste)) {
        e.preventDefault();
      }
    };
    const {
        name,
        description,
        event_type,
        interested_type,
        start_time,
        end_time,
        notification_config_id,
        userids,
        groupids,
        hostids,
        repeat_id,
        n_repeat,
        type_repeat,
        occurrence,
        usergroupids}=ManttoData;
    return(
       <>
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+"   "+lang[languaje]['evento'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                <div className="form-GS-box"> 
                                    
                                    
                                    
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="name"  type="text" value={name}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['titulo'])}{(name=="")?reqField():''}</label>
                                        
                                    </div>
                                   
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="description"  type="text" value={description}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</label>
                                        
                                    </div>
                                    
                                    
                                    <div className="user-box-GS" style={{height:'16%'}}>
                                    {/* <input required name="start_time" min={obtenerFechaActualLocal} type="datetime-local" value={start_time}
                                    onChange={handleChange} />
                                        <label className='label-GS active'>{capitalizeFirstLetter(lang[languaje]['fechaInicio'])}</label>
                                        */}
                                        <div className="date-selector date-calendar">
      
                              <DateRangePicker
                                value={range}
                                ranges={predefinedRanges}
                                onChange={(value) => setRange(value)}
                                className="reporte-gs-datepicker"
                                placeholder="Seleccione un rango de fechas"
                                showOneCalendar={false} // Opcional: muestra solo un calendario
                                format="yyyy-MM-dd HH:mm" // Formato con horas
                                showMeridian // Si deseas mostrar el formato AM/PM
                                size='xs'
                                
                                shouldDisableDate={date => isBefore(date, startOfDay(new Date()))}
                              />

<label className='label-GS active'>{capitalizeFirstLetter(lang[languaje]['rangoFechas'])}</label>
      
    </div>
                                    </div>
                                    {/* <div className="user-box-GS" style={{height:'16%'}}>
                                    <input required name="end_time"  type="datetime-local" value={end_time}
                                    onChange={handleChange} min={start_time} />
                                        <label className='label-GS active'>{capitalizeFirstLetter(lang[languaje]['fechaFin'])}</label>
                                       
                                        
                                    </div> */}
                                <div className="user-box-GS"  style={{height:'13%'}}>
                                    {
                                            
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={'TODOS'}  opt_de={repeat_id} origen={'Admin'} data={repeat}   titulo='Repeat' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['repetir'])}</label>
                                        
                                    </div>
                                    {
                                      (repeat_id==6)?
                                      <div className="user-box-GS"  style={{height:'13%' ,justifyContent:'space-between'}} >
                                         <input required name="n_repeat" style={{height:'8%',position:'relative',top:'4%'}}   type="number" min='2' value={n_repeat}
                                        onChange={handleChange} onKeyPress={handleKeyPress} 
                                        onPaste={handlePaste}    />
                                      <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={'TODOS'}  opt_de={type_repeat} origen={'Admin'} data={repeat.slice(1, -1)}   titulo='RepeatType' selectFunction={changeOption} index={0}></SelectorAdmin>
                                  <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['RepeticionPersonalizadas'])}{(n_repeat==0)?reqField():''}</label>
                                  
                              
                              
                                      </div>:''
                                    }
                                    {
                                      (repeat_id!=0)?
                                      <div className="user-box-GS"  style={{height:'13%' ,justifyContent:'space-between'}} >
                                        <input required name="occurrence" style={{height:'20%'}}   type="number" min='2' value={occurrence}
                                        onChange={handleChange} onKeyPress={handleKeyPress} 
                                        onPaste={handlePaste}    />
                                        <label className='label-GS' htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['finalizaRepeticiones'])}{(occurrence==0)?reqField():''}</label>
                                     </div>:''
                                    }
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    {
                                            
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={'TODOS'}  opt_de={levels.find(element => element.name === ManttoData.event_type).id} origen={'Admin'} data={levels}   titulo='Severity' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['tipoMantenimiento'])}</label>
                                        
                                    </div>
                                   
                                    {
                                        (ManttoData.event_type=="group")?
                                        <div className="user-box-GS"  style={{height: 'auto',minHeight: '13%'}}>
                                    
                                        {
                                            (dataGroups.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <MultiSelector placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={''}  opt_de={groupids} origen={'Admin'} data={dataGroups.data.data}   loading={dataGroups.loading}  titulo='Grupos' selectFunction={changeMultiOption} index={0}></MultiSelector>
                                        }
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['grupos'])}{(groupids.length==0)?reqField():''}</label>
                                        
                                    </div>:
                                    <div className="user-box-GS"  style={{height: 'auto',minHeight: '20%'}}>
                                      <div className='txtdevicesSelected'>{"("+poolRows.length+")"+capitalizeFirstLetter(lang[languaje]['hostSelected'])}</div>
                                    {
                                      (loading)?'':
                                      <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['agregar'])}  action={openAddHostModal}/>
                                    }
                                    <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['dispositivos'])}{(hostids.length==0)?reqField():''}</label>
                                    
                                </div>
                                    }
                                    <div className="user-box-GS"  style={{height: 'auto',minHeight: '13%'}}>
                                    {/* <input required name="groupids"  type="text" value={groupids}
                                    onChange={handleChange} disabled /> */}
                                        {
                                            (dataUsers.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <MultiSelector placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={''}  opt_de={userids} origen={'Admin'} data={dataUsers.data.data}   loading={dataUsers.loading}  titulo='Usuarios' selectFunction={changeMultiOption} index={0}></MultiSelector>
                                        }
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['usuarios'])}{(userids.length==0)?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height: 'auto',minHeight: '13%'}}>
                                    {/* <input required name="groupids"  type="text" value={groupids}
                                    onChange={handleChange} disabled /> */}
                                        {
                                            (dataNotiConfig.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={false} txtOpGen={''}  opt_de={notification_config_id} origen={'Admin'} data={dataNotiConfig.data.data}   loading={dataNotiConfig.loading}  titulo='Estados' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['alertas'])}</label>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div className="user-box-GS" style={{height:'13%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateManttoModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            {
                                                (editActive)?<Action disabled={false} origen='Red' titulo={capitalizeFirstLetter(lang[languaje]['eliminar'])}  action={openDeleteUserModal}/>:''
                                            }
                                            
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                   
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
        
       </>
    )
}

export default ModalCreateException